import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Zap } from "lucide-react";
import api from "../../lib/api";
import { useAuth } from "../../contexts/AuthContext";

export default function ShopOverview() {
  const { user } = useAuth();
  const [usage, setUsage] = useState({});
  const [products, setProducts] = useState([]);
  useEffect(()=>{
    api.get("/ai/usage/me").then(r=>setUsage(r.data));
    api.get("/products?limit=20").then(r=>setProducts(r.data.items));
  }, []);
  const pct = usage.daily_limit ? Math.min(100, (usage.today/usage.daily_limit)*100) : 0;
  return (
    <div className="space-y-8">
      <div><div className="overline mb-2">Hello, {user?.name}</div><h1 className="font-display text-4xl text-white">Shop Assistant</h1></div>
      <div className="grid md:grid-cols-2 gap-4">
        <div className="card-luxe p-6">
          <div className="overline mb-3">AI Generations Today</div>
          <div className="font-display text-4xl text-white">{usage.today||0}<span className="text-white/30 text-xl">/{usage.daily_limit||0}</span></div>
          <div className="h-1 bg-white/5 mt-3"><div className="h-full bg-copper" style={{width:`${pct}%`}}/></div>
          <div className="text-xs text-white/40 mt-3">Monthly: {usage.month||0}/{usage.monthly_limit||0}</div>
          {usage.paused && <div className="text-xs text-red-400 mt-2">● AI access paused by Developer</div>}
        </div>
        <div className="card-luxe p-6 flex flex-col justify-between">
          <div>
            <div className="overline mb-3">Quick Action</div>
            <div className="font-display text-2xl text-white">Add a new product</div>
            <p className="text-white/50 text-sm mt-2">Upload an image and generate AI photo variations using Gemini Nano Banana.</p>
          </div>
          <Link to="/shop-dashboard/add-product" className="btn-primary mt-4 self-start"><Plus size={13}/> Add Product</Link>
        </div>
      </div>
      <div className="card-luxe p-6">
        <div className="overline mb-4">Latest Products</div>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
          {products.slice(0,10).map(p => (
            <div key={p.id} className="aspect-square bg-[#070707] overflow-hidden relative">
              <img src={p.images?.[0]} alt="" className="w-full h-full object-cover"/>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-2"><div className="text-xs text-white truncate">{p.name}</div></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
